export namespace Constants {
	export const COUNTRYKEY = 'countryKey';
	export const COUNTRYNAMEKEY = 'countryName';
}
